import { FASTElement, attr, customElement } from '@microsoft/fast-element';
import type { ValuesOf } from '@microsoft/fast-foundation';

import template from './template.js';
import styles from './styles.js';

export const HeaderView = {
	default: 'default',
	scroll: 'scroll'
} as const;

export type HeaderView = ValuesOf<typeof HeaderView>;

@customElement({
	name: 'site-header',
	template,
	styles
})
export class Header extends FASTElement {
	@attr
	public view: HeaderView = HeaderView.default;
}